import { Divider } from '@mui/material'
import React from 'react'
import '../styles/divider.scss'

export const OPDivider = (): JSX.Element => {
  return <Divider className='opDivider' variant='fullWidth' />
}
